import { useState, useCallback } from "react";
import privateAxios from "../../utils/axiosPrivate";
import { getCreditAvailabilityFundingURL } from "../../utils/constants/apiEndPoints";
import { showToast } from "../../utils/utils";
import { showToastType } from "../../utils/constants/appConstants";

export const useCreditLimit = () => {
  const [creditData, setCreditData] = useState({});

  const loadCredit = useCallback(async () => {
    try {
      const res = await privateAxios.get(getCreditAvailabilityFundingURL);
      setCreditData(res?.data?.data || {});
    } catch (err) {
      showToast(
        err?.response?.data?.message || showToastType?.errorText,
        showToastType?.error
      );
      setCreditData({});
    }
  }, []);

  return { creditData, loadCredit };
};
